import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=1815dd52&scoped=true"
import script from "./positionList.vue?vue&type=script&lang=js"
export * from "./positionList.vue?vue&type=script&lang=js"
import style0 from "./positionList.vue?vue&type=style&index=0&id=1815dd52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815dd52",
  null
  
)

export default component.exports